/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'GoalLinker.error.generic.description': 'Verifique a conexão com a Internet e tente outra vez.',
  'GoalLinker.error.generic.header': 'Algo deu errado',
  'GoalLinker.error.linking.header': 'Não foi possível vincular a meta',
  'GoalLinker.error.max-entities-to-goal.description':
    'Só é permitido vincular até 100 {entities} a uma meta. Remova uma {entity} se quiser vincular mais {entities}.',
  'GoalLinker.error.max-entities-to-goal.header': 'Limite de 100 {entity} atingido',
  'GoalLinker.error.max-goals.description':
    'No máximo 100 metas podem ser vinculadas. Remova metas vinculadas para vincular outras metas.',
  'GoalLinker.error.max-goals.header': 'Limite de 100 metas atingido',
  'GoalLinker.goal-row.open-goal': 'Abrir meta',
  'GoalLinker.link-goals.error-description': 'Algo deu errado, verifique sua conexão com a internet e tente de novo.',
  'GoalLinker.link-goals.error-title': 'Não foi possível desvincular a meta',
  'GoalLinker.linked-goals.header': 'Metas vinculadas',
  'GoalLinker.linked-goals.show-less': 'Mostrar menos',
  'GoalLinker.linked-goals.show-more': 'Mostrar {count} mais',
  'GoalLinker.recents.emptystate-jira-product-discovery.description':
    'Vincule ideias a metas para acompanhar como o trabalho contribui para os resultados',
  'GoalLinker.recents.emptystate-project.description':
    'Vincule seu projeto a metas para acompanhar como o trabalho leva aos resultados',
  'GoalLinker.recents.emptystate.description':
    'Vincule tickets a metas para acompanhar como o trabalho leva aos resultados',
  'GoalLinker.recents.emptystate.header': 'Comece a usar as metas',
  'GoalLinker.recents.header': 'Metas recentes',
  'GoalLinker.search.emptystate.description': 'Verifique se há erros de digitação',
  'GoalLinker.search.emptystate.header': 'Nenhum resultado correspondente',
  'GoalLinker.search.label': 'Resultados',
  'GoalLinker.search.placeholder': 'Pesquisar metas ou colar link',
};
